// removed by extract-text-webpack-plugin
module.exports = {"nf-search-badge":"nf-search-badge","nf-search-badge__name":"nf-search-badge__name","nf-search-badge__more-text":"nf-search-badge__more-text"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SolicitationsSearchBar/subComponents/SearchBadge/SearchBadge.scss
// module id = 4936
// module chunks = 1